export enum MembersSortOrder {
    None = 0,
    FirstName = 1,
    LastName = 2,
}

export enum MembersSortDirection {
    Ascending = 0,
    Descending = 1,
}